//@ts-strict-ignore
import React, { useContext } from 'react';
import gridStyles from '../../styles/partials/_grid.css';
import TabContext from '../Context/TabContext';

/**
 * Grid Wrapper to resolve layout when nested in forms + to stop render when not in an active tab to avoid focus capture issues.
 * @param children      - Child grid component.
 * @param alwaysActive  - Override to make a grid always be visible, such as when it is not nested inside a tab.
 */
const GridContainer = ({ children, alwaysActive = false }) => {
  const tab = useContext(TabContext);
  if (alwaysActive || tab?.isActiveTab) {
    return <div className={gridStyles.gridContainer}>{children}</div>;
  }
  return null;
};

export default GridContainer;
